import React, { useState } from 'react'
import { Form, Input, Modal,  App, Button } from 'antd';
import { useKehukpxxAddMutation } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';

function ClientInvoiceAdd(props) {
    const [open, setOpen] = useState(false);
    const { message } = App.useApp();   
    const [info, setInfo] = useState({
        'khkpxx_kh_id': props.kh_id,
        'khkpxx_type_id': '1',
        'khkpxx_type_name': '1',
        'khkpxx_name': '',
        'khkpxx_code': '',
        'khkpxx_cid': props.yh_id,
        'khkpxx_cname': props.yh_name,
        'khkpxx_content': '',
        'khkpxx_dizhi': '',
        'khkpxx_khh': '',
        'khkpxx_yhzh': '',
        'khkpxx_dh': '',
    });
    const [form] = Form.useForm();
    const [submit] = useKehukpxxAddMutation();
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} title='新增开票信息'/>
            <Modal
                open={open}
                title='新增开票信息'
                width={800}
                onCancel={() => {setOpen(false)}} 
                footer={[
                    <Button key='submit' type='primary' onClick={() => {                        
                        submit(info).then(res => {
                            if(res.data.Status === 'success'){
                                message.success('新增成功');
                                setOpen(false);
                                form.resetFields();
                                setInfo(prevState=>({...prevState,khkpxx_name:'',khkpxx_code:'',khkpxx_dizhi:'',khkpxx_khh:'',khkpxx_yhzh:'',khkpxx_dh:'',khkpxx_content:''}))
                            }else{
                                message.error('新增失败'+res.data.Message);
                            }
                        });
                    }}>保存</Button>,
                    <Button key='reset' onClick={() => {
                        form.resetFields();
                        setInfo(prevState=>({...prevState,khkpxx_name:'',khkpxx_code:'',khkpxx_dizhi:'',khkpxx_khh:'',khkpxx_yhzh:'',khkpxx_dh:'',khkpxx_content:''}))
                    }}>重置</Button>,
                ]}
            >
                <Form form={form} name='form_client_invoice_add' labelCol={{span: 4}} wrapperCol={{span: 20}}>
                    <Form.Item name='khkpxx_name' label='单位名称' rules={[{ required: true, message: '请输入单位名称' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_name: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_code' label='单位税号' rules={[{ required: true, message: '请输入企业代码' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_code: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_dizhi' label='地址'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_dizhi: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_khh ' label='开户行'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_khh: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_yhzh' label='银行账号'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_yhzh: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_dh' label='电话'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_dh: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khkpxx_content' label='备注'>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khkpxx_content: e.target.value}))}} />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientInvoiceAdd